import {RenamedSlug} from '../resources/RenamedSlug';
import {DomainEvent} from './DomainEvent';

export class SlugRenamed<EntityClass> extends DomainEvent<RenamedSlug<EntityClass>> {}
